module.exports = __webpack_public_path__ + "assets/img/dzh-17.508d9e20.jpg";